import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { WifiOffIcon, WifiIcon } from 'lucide-react';
import { useOnlineStatus } from '../../app/hooks/useOnlineStatus';
/**
 * F5.6 Offline Indicator
 *
 * - Toont een amber banner zolang de gebruiker offline is.
 * - Toont kort (3s) een groene "weer online" bevestiging na herstel.
 * - Niet-blokkerend: alle practice-functies blijven client-side werken.
 * - Respecteert safe-area-inset-top voor iPhones met notch.
 */
export function ConnectionStatus() {
  const {
    isOnline,
    wasOffline
  } = useOnlineStatus();
  const showOffline = !isOnline;
  const showReconnected = isOnline && wasOffline;
  return <AnimatePresence data-id="element-2485" data-mp="2ndaly38hbtsm">
      {showOffline && <motion.div key="offline" role="status" aria-live="polite" initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed top-0 inset-x-0 z-[60] pt-safe" data-id="element-2486" data-mp="2s99b3t1mtfu3">
        
          <div className="mx-auto max-w-2xl m-2 px-4 py-2.5 rounded-xl bg-amber-100 border border-amber-300 text-amber-900 shadow-md flex items-center gap-3" data-id="element-2487" data-mp="239j9rylthjr8">
            <WifiOffIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-2488" data-mp="2d1f91czn3fx1" />
            {/*
             Deze tekst beloofde eerder dat voortgang "wordt opgeslagen zodra
             je weer verbinding hebt". Dat kan de app niet waarmaken: er is
             geen wachtrij, alleen een debounce die pusht zolang de app open
             en online is. Wordt dit apparaat nooit meer online geopend, dan
             blijft het werk hier staan. Wat wél altijd waar is, staat er nu:
             lokaal bewaard, en meesturen gebeurt bij de volgende keer online.
             */}
            <p className="text-xs sm:text-sm font-semibold leading-tight" data-id="element-2489" data-mp="35pku60ulv6xe">
              Je bent offline — je werk wordt op dit apparaat bewaard en gaat
              mee zodra je hier weer online bent.
            </p>
          </div>
        </motion.div>}

      {showReconnected && <motion.div key="reconnected" role="status" aria-live="polite" initial={{
      y: -40,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -40,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed top-0 inset-x-0 z-[60] pt-safe" data-id="element-2490" data-mp="38tilxtm0u5ef">
        
          <div className="mx-auto max-w-2xl m-2 px-4 py-2.5 rounded-xl bg-emerald-100 border border-emerald-300 text-emerald-900 shadow-md flex items-center gap-3" data-id="element-2491" data-mp="2p3ykx5c6e1gy">
            <WifiIcon className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-2492" data-mp="2u06wk8r5zcjd" />
            <p className="text-xs sm:text-sm font-semibold leading-tight" data-id="element-2493" data-mp="2z0bf04bmuhc8">
              Je bent weer online!
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}